// A value namespace, not a type: the single call site is
// `WebcamUtil.getAvailableVideoInputs()` and nothing ever instantiates it.
export const WebcamUtil = {
  /**
   * Lists available videoInput devices
   * @returns a list of media device info.
   */
  getAvailableVideoInputs(): Promise<MediaDeviceInfo[]> {
    if (!navigator.mediaDevices || !navigator.mediaDevices.enumerateDevices) {
      return Promise.reject(new Error('enumerateDevices() not supported.'));
    }

    return new Promise((resolve, reject) => {
      navigator.mediaDevices
        .enumerateDevices()
        .then((devices: MediaDeviceInfo[]) => {
          resolve(devices.filter((device: MediaDeviceInfo) => device.kind === 'videoinput'));
        })
        .catch((error: unknown) => {
          // Rejecting with the bare message used to lose the stack and left
          // callers with a string where they expect an Error.
          reject(error instanceof Error ? error : new Error(String(error)));
        });
    });
  },
} as const;
